import type { FC } from 'react';

import { ChatProvider } from '@apps/chat-shared-multilabel/ChatProvider';
import type { AppProps } from '@eneco/next';

const MainApp: FC<AppProps> = ({ Component, pageProps: { session, ...pageProps }, router }) => {
  return (
    <ChatProvider>
      <Component {...pageProps} />
    </ChatProvider>
  );
};

export default MainApp;
